export default "__VITE_ASSET__DNCeK_5N__"